<template>
  <div>
    <button
      type="button"
      :class="[
        'btn btnclass smallerfontsize mr-3',
        genresSelected ? 'selected' : ''
      ]"
      @click="fieldData.showGenreModal = true"
    >
      Genre
    </button>
    <b-modal
      id="modal-genres"
      v-model="fieldData.showGenreModal"
      size="lg"
      title="Choose Genre"
      @shown="popupIsShown"
      @ok="saveGenres"
    >
      <b-tabs content-class="px-2">
        <GenrePickerGenre
          v-bind="$props"
          :genres-array="fieldData.genreOptionArray"
          :config-array="configArray"
        />
      </b-tabs>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          @click="ok()"
        >
          Save
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import GenrePickerGenre from "./GenrePickerGenre";

export default {
  name: "GenreModal",
  data() {
    return {
      configArray: []
    };
  },
  components: {
    GenrePickerGenre
  },
  props: ["field-data"],
  computed: {
    genresSelected(){
      let genres = this.$store.getters["searchApiBody/getPayload"].GenreConfigs
      let areGenresSelected = genres.length > 0
      return areGenresSelected
    }
  },
  methods: {
    popupIsShown(){
      document.addEventListener("keyup", this.onKeyUp);
      this.configArray = [...this.$store.getters["searchApiBody/getPayload"].GenreConfigs];
    },
    saveGenres() {
      let payload = this.$store.getters["searchApiBody/getPayload"]
      payload.GenreConfigs = [...this.configArray];
      this.$store.commit(
          'searchApiBody/updatePayload',
          payload,
        );
    }, 
    popupIsHidden(){
      document.removeEventListener("keyup", this.onKeyUp);
    },
    onKeyUp(event) {
      if (event.key === "Enter" && this.fieldData.showGenreModal) {
        this.fieldData.showGenreModal = false;
        this.saveGenres()
      }
    },
  }
};
</script>
<style scoped>
label {
  width: 100%;
}
</style>
